module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 1 GREEN.862bd88.svg";